import { BASE_DOMAIN } from "../api/axios"

export const BASE_ROUTE = "/cms" // don't add '/' at end off BASENAME for breadcrumbs
export const BASE_TITLE = " Ether Daylight Systems pvt ltd"
export const BASE_API = `${BASE_DOMAIN}/ether/cms/api/v1/`

export const CONFIG = {
  layout: "vertical", // vertical, horizontal
  subLayout: "", // horizontal-2
  collapseMenu: false, // mini-menu
  layoutType: "menu-light", // menu-dark, menu-light, dark
  headerBackColor: "header-dark", // header-blue, header-red, header-purple, header-info, header-green header-dark
  rtlLayout: false,
  navFixedLayout: true,
  headerFixedLayout: true,
  boxLayout: false,
  token: "",
  userPermission: "",
  currentUser: ""
}
